export const getters = {
    cartItems: (state) => state.items,
    cartItemCount: (state) => state.items.length,
    cartTotalPrice: (state) => state.items.reduce((total, item) => total + item.price * item.quantity, 0)
  };